let Toggle = require('../components/toggle.vue');
let Http = require('./http');

module.exports = {
	mixins: [Http],

	props: {
		item: {
			required: true,
			type: [Object]
		},
		onText: {
			type: String,
			default: ''
		},
		offText: {
			type: String,
			default: ''
		}
	},
	
	data(){
		return{
			toggledOnText: this.onText,
			toggledOffText: this.offText,
			addEndpoint: '',
			removeEndpoint: '',
		}
	},
	
	components:{
		'toggle' : Toggle
	},
	
	computed: {
		activateEndpoint() {
			return this.addEndpoint + this.item.id;
		},
		deactivateEndpoint() {
			return this.removeEndpoint + this.item.id;
		}
	},
	
	methods: {
		activate() {
			this.sendRequest(this.activateEndpoint, 'post');
			this.$root.$emit('activated', this.item);
		},
		
		deactivate() {
			this.sendRequest(this.deactivateEndpoint, 'post');
			this.$root.$emit('deactivated', this.item);
		},
	}
}
